import Button from '@/common/component/Button';
import clsx from 'clsx';
import React from 'react';

export function ReactionButton({ active, className, count, isInDetail, disabled, icon: Icon, onClick }) {
    return (
        <Button
            className={clsx('betbook-reactions-item flex-center flex-1', className, {
                active,
                'mr-15': isInDetail
            })}
            onClick={onClick}
            disabled={disabled}
        >
            <div
                className={clsx('flex items-center justify-center flex-col', {
                    'flex-row mr-5': isInDetail
                })}
            >
                {' '}
                <div
                    className={clsx({
                        'mr-5': isInDetail
                    })}
                >
                    <Icon />
                </div>{' '}
                <div className="fs-14 pb-2">{count}</div>
            </div>
        </Button>
    );
}
